import AddressDelivery from "component/AddressDelivery";
import AddressDetails from "component/AddressDetails";
import AddressHelp from "component/AddressHelp";
import CheckoutStepper from "component/CheckoutStepper/CheckoutStepper";
import React, { useEffect } from "react";
import "./AddressPage.css";
import Service from "services/service";
import { globalStore } from "stores/globalStore";

const AddressPage = () => {
  const { addressPageData, setAddressPageData } = globalStore();

  const getAllAddress = async () => {
    try {
      const response = await Service.getAllAddress();
      setAddressPageData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllAddress();
  }, []);
  return (
    <div className="address-1">
      <CheckoutStepper currentStep={1} />
      <div className="address__column">
        <div className="address__details">
          <AddressDetails />
          <AddressDelivery />
        </div>
        <AddressHelp />
      </div>
    </div>
  );
};

export default AddressPage;
